
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PagesManager from '@/components/admin/PagesManager';
import { useLanguage } from '@/contexts/LanguageContext';
import { useUserDashboardData } from '@/hooks/useUserDashboardData';
import { Loader2 } from 'lucide-react';

const PagesManagerPage: React.FC = () => {
  const { direction } = useLanguage();
  const { isLoading, user } = useUserDashboardData();
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2">טוען נתוני משתמש...</span>
      </div>
    );
  }
  
  return (
    <div className={direction === 'rtl' ? 'rtl' : 'ltr'}>
      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="text-3xl font-bold">ניהול דפים</CardTitle>
          <p className="text-muted-foreground">יצירה ועריכה של דפי התצוגה</p>
        </CardHeader>
        <CardContent>
          {user && (
            <div className="mb-4 text-sm text-muted-foreground">
              משתמש: {user.email} | תפקיד: {user.role || 'משתמש רגיל'}
            </div>
          )}
        </CardContent>
      </Card>
      <PagesManager />
    </div>
  );
};

export default PagesManagerPage;
